var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { attrs: { id: "paramsGenerator" } },
        [
          _c(
            "v-card",
            { attrs: { "max-width": "800px" } },
            [
              _c("v-card-title", [_vm._v(_vm._s(_vm.title))]),
              _c(
                "v-card-text",
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.moduleList,
                      "item-text": "name",
                      "item-value": "id",
                      label: "Learning Module",
                      outlined: "",
                      "return-object": ""
                    },
                    model: {
                      value: _vm.selectedModule,
                      callback: function($$v) {
                        _vm.selectedModule = $$v
                      },
                      expression: "selectedModule"
                    }
                  }),
                  _c("v-select", {
                    attrs: {
                      items: _vm.locales,
                      "item-text": "name",
                      "item-value": "code",
                      label: "Preferred Language",
                      outlined: ""
                    },
                    model: {
                      value: _vm.locale,
                      callback: function($$v) {
                        _vm.locale = $$v
                      },
                      expression: "locale"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: { label: "Redirect URL", outlined: "" },
                    model: {
                      value: _vm.redirectURL,
                      callback: function($$v) {
                        _vm.redirectURL = $$v
                      },
                      expression: "redirectURL"
                    }
                  }),
                  _c("v-textarea", {
                    attrs: {
                      readonly: "",
                      value: _vm.customParams,
                      label: "Custom Params",
                      outlined: "",
                      hint:
                        "Copy and paste this into your LMS under custom parameters",
                      "persistent-hint": ""
                    }
                  }),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1" },
                      on: { click: _vm.copyToClipboard }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("integrations.label.copyToClipboard")) +
                          " "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    { attrs: { color: "primary" }, on: { click: _vm.cancel } },
                    [_vm._v(" " + _vm._s(_vm.$t("global.close")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }